import type { FunctionComponent, PropsWithChildren } from 'react';
import { useVoucherToolEnabled } from '@/hooks/useVoucherToolEnabled';
import UnAuthorized from '@/pages/UnAuthorized';

/**
 * Blocks the voucher template pages when the lift operator does not have the
 * voucher tool switched on. Permissions alone are not enough: the pages stay
 * reachable by direct link once a user holds VOUCHER_TEMPLATE_NAV.
 */
export const VoucherToolGuard: FunctionComponent<PropsWithChildren> = ({
    children,
}) => {
    const { enabled, isLoading } = useVoucherToolEnabled();

    if (isLoading) return null;
    if (!enabled) return <UnAuthorized />;

    return <>{children}</>;
};
